import {WINDOW_MODE_MOBILE_WIDTH, WINDOW_MODE_TABLET_WIDTH} from 'consts/common'
import {WindowModeType} from 'types/commons'

export function getWindowMode(
  width: number = window.innerWidth,
): WindowModeType {
  if (width <= WINDOW_MODE_MOBILE_WIDTH) {
    return 'mobile'
  }
  if (width <= WINDOW_MODE_TABLET_WIDTH) {
    return 'tablet'
  }
  return 'website'
}
